import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const AnalyticsPurchaseConfirmation = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '1',
    screen: 'tela intermediária',
    content_action: 'dado carregado',
    product: 'sortezinha',
    flow: 'prateleira',
  })
}

export const AnalyticsScratchNow = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '1',
    screen: 'tela intermediária',
    action_id: 'Raspar',
    content_action: 'toque',
    product: 'sortezinha',
    flow: 'prateleira',
  })
}

export const AnalyticsSeeReceipt = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '1',
    screen: 'tela intermediária',
    action_id: 'Conferir comprovante',
    content_action: 'toque',
    product: 'sortezinha',
    flow: 'prateleira',
  })
}
